import { RootState } from "store/store";

export const cropSelector = (state: RootState) => state.crop;
